import React,{useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';

const Summary_loan_out_table = () => {
    const { initState } = useContext(GlobalContext);
    return (
        <div className="mt-6">
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">پوختەی قەرزی ماوە</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <tbody className="divide-y divide-slate-50">
                        <tr>
                            <th className="bg-slate-50 border-b border-slate-100 px-6 py-3 text-right text-base font-semibold text-slate-500 uppercase tracking-wide">
                                کۆی قەرزی ماوە
                            </th>
                            <td className="bg-white px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(initState?.summary_loan_out_report))}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Summary_loan_out_table